"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyElement = exports.StickyPosition = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var DeviceManager_1 = require("./DeviceManager");
var StickyPosition;
(function (StickyPosition) {
    StickyPosition["TOP"] = "TOP";
    StickyPosition["BOTTOM"] = "BOTTOM";
})(StickyPosition = exports.StickyPosition || (exports.StickyPosition = {}));
var StickyElement = /** @class */ (function () {
    function StickyElement(el, position) {
        this.stickyClass = 'is-sticky';
        this.el = el;
        this.deviceManager = new DeviceManager_1.DeviceManager();
        this.position = position;
        this.manageClass();
        this.attachEvents();
    }
    StickyElement.prototype.setElement = function (el) {
        this.el = el;
    };
    StickyElement.prototype.manageClass = function () {
        if (this.shouldBeSticky()) {
            this.el.style.height = "".concat(this.el.offsetHeight, "px");
            this.el.classList.add(this.stickyClass);
        }
        else {
            this.el.style.height = 'auto';
            this.el.classList.remove(this.stickyClass);
        }
    };
    StickyElement.prototype.shouldBeSticky = function () {
        return window.pageYOffset >= (0, dom_interact_1.getPositionRelativeToDocument)(this.el).top - this.getOffset();
    };
    StickyElement.prototype.getOffset = function () {
        return this.getStickyPosition() === StickyPosition.TOP ? 0 : window.innerHeight;
    };
    StickyElement.prototype.getStickyPosition = function () {
        if (this.position) {
            return this.position;
        }
        return this.deviceManager.getCurrentState() === DeviceManager_1.MOBILE ? StickyPosition.BOTTOM : StickyPosition.TOP;
    };
    StickyElement.prototype.attachEvents = function () {
        var _this = this;
        window.addEventListener('scroll', function () { return _this.manageClass(); });
        window.addEventListener('resize', function () { return _this.manageClass(); });
    };
    return StickyElement;
}());
exports.StickyElement = StickyElement;
